export const container = 'px-2';
export const sectionContainer = '';
export const sectionIcon = '';
export const sectionTitle = 'mt-4 text-normal font-semibold';
export const sectionSubtitle = 'text-xs';
export const inputContainer = ' my-4';
export const inputLabel = 'font-semibold';
export const inputHint = 'font-normal text-xs';
export const selectInputlabel = 'text-sm font-semibold';
export const selectInput = '';
export const gridContainer = 'grid grid-cols-1 md:grid-cols-2 gap-4';
export const cardContainer = 'flex items-center mt-4';
export const hiddenFileInput = 'hidden';
export const fileUploadLabel = 'flex flex-col items-center';
export const uploadIcon = 'h-8 w-8 mb-2';
export const fileUploadText = 'text-sm';
export const fileUploadHint = 'text-xs';
export const saveButtonContainer = 'w-full flex justify-center items-center';
export const saveButton = 'w-full bg-custom-button-green flex items-center gap-4';
export const saveButtonText = '';
export const arrowIcon = 'mt-1';
